export default __webpack_public_path__ + "static/media/android.2ed766a4.svg";